import * as tslib_1 from "tslib";
import { PropostaStateService } from './../../../../../shared/states/proposta-state.service';
import { MicrocreditoService } from './../../../../services/microcredito.service';
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FaefStateService } from './../faef-state.service';
import * as toastr from 'toastr';
export class DadosFinanceirosComponent {
    constructor(fb, state, propostaState, service) {
        this.fb = fb;
        this.state = state;
        this.propostaState = propostaState;
        this.service = service;
        this.next = new EventEmitter();
        this.previous = new EventEmitter();
        this.loading = new EventEmitter(true);
    }
    ngOnInit() {
        this.createForms();
        const faef = this.state.getLast();
        if (faef.faefFinanceiroEmpreendimento) {
            this.financeiroForm.patchValue(faef.faefFinanceiroEmpreendimento, { emitEvent: false });
        }
    }
    createForms() {
        this.financeiroForm = this.fb.group({
            despesasOperacionaisNegocio: ['', Validators.required],
            despesasAlimentacaoFamilia: ['', Validators.required],
            despesasAluguelResidencial: ['', Validators.required],
            despesasVestuarioFamilia: ['', Validators.required],
            despesasEducacaoFamilia: ['', Validators.required],
            despesasServicosDiversos: ['', Validators.required],
            despesasMoveisEletrodomesticos: ['', Validators.required],
            somaRendaFamiliar: ['', Validators.required],
            somaCaixaBanco: ['', Validators.required],
            contasReceber: ['', Validators.required],
            estoque: ['', Validators.required],
            veiculos: ['', Validators.required],
            maquinasEquipamentos: ['', Validators.required],
            dividaFornecedores: ['', Validators.required],
            contasPagar: ['', Validators.required]
        });
    }
    onClickNext() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.updateState();
            yield this.calculateFaef();
            this.next.emit();
        });
    }
    onClickPrevious() {
        this.updateState();
        this.previous.emit();
    }
    updateState() {
        const faef = this.state.getLast();
        const financeiro = this.financeiroForm.value;
        faef.faefFinanceiroEmpreendimento = {
            despesasOperacionaisNegocio: Number(financeiro.despesasOperacionaisNegocio),
            despesasAlimentacaoFamilia: Number(financeiro.despesasAlimentacaoFamilia),
            despesasAluguelResidencial: Number(financeiro.despesasAluguelResidencial),
            despesasVestuarioFamilia: Number(financeiro.despesasVestuarioFamilia),
            despesasEducacaoFamilia: Number(financeiro.despesasEducacaoFamilia),
            despesasServicosDiversos: Number(financeiro.despesasServicosDiversos),
            despesasMoveisEletrodomesticos: Number(financeiro.despesasMoveisEletrodomesticos),
            somaRendaFamiliar: Number(financeiro.somaRendaFamiliar),
            somaCaixaBanco: Number(financeiro.somaCaixaBanco),
            contasReceber: Number(financeiro.contasReceber),
            estoque: Number(financeiro.estoque),
            veiculos: Number(financeiro.veiculos),
            maquinasEquipamentos: Number(financeiro.maquinasEquipamentos),
            dividaFornecedores: Number(financeiro.dividaFornecedores),
            contasPagar: Number(financeiro.contasPagar)
        };
        this.state.setState(faef);
    }
    calculateFaef() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.loading.emit(true);
                const faef = yield this.service.calculate(this.state.getLast(), this.propostaState.getLast().cliente);
                this.state.setState(faef);
            }
            catch (error) {
                console.log(error);
                toastr.error('Não foi possível efetuar o cálculo do FAEF', 'Falha ao comunicar com servidor');
                throw error;
            }
            finally {
                this.loading.emit(false);
            }
        });
    }
}
